import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {AnalyseStarterService} from '../../shared/services/analyse-starter.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyseStarterGuard {
  constructor(
    private readonly analyseStarted: AnalyseStarterService,
    private readonly router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkSelectionWithNavigation(next);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.checkSelectionWithNavigation(next);
  }

  public checkModuleSelected(): boolean {
    if (this.analyseStarted.isForModule2 !== null) {
      return true;
    }
    return false;
  }

  private async checkSelectionWithNavigation(
    next: ActivatedRouteSnapshot
  ): Promise<boolean> {
    if (this.checkModuleSelected()) {
      if (!this.analyseStarted.routeIsForSelectedModule(next.routeConfig)) {
        await this.analyseStarted.setFlagsAndStartAnalysis(
          !this.analyseStarted.isForModule2
        );
      }
      return true;
    }
    return this.router.navigate(['/home'], {replaceUrl: true});
  }
}
